<!-- Copyright (c) 2024 MOCA Systems, Inc.	All rights reserved. -->

<form mat-dialog-content [formGroup]="formGroup" (ngSubmit)="onNext()">
	<checkbox-list
		formControlName="esidDisambiguationCheckList"
		checkboxSide="left"
		class="esid-disambiguation-content"
	>
		<!-- <checkbox-set
			[label]="appStrings.IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_CREATE_NEW_TICKETS_FOR_ALL"
			class="select-all-checkbox-set"
			[ids]="createNewTicketsIds$ | async"
		></checkbox-set> -->
		<checkbox-set
			[label]="appStrings.IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_UPDATE_ALL_TICKETS"
			class="select-all-checkbox-set"
			[ids]="updateTicketsIds$ | async"
		></checkbox-set>
		<ng-container *ngFor="let esidDisambiguationItem of esidDisambiguationCheckList$ | async">
			<h4 *ngIf="esidDisambiguationItem.originalModel?.showHeader" class="esid-section-header">
				{{ esidDisambiguationItem.originalModel?.esid }}
			</h4>
			<checkbox-list-item [id]="esidDisambiguationItem.id" class="checkbox-list-item">
				<ng-template customCheckboxContent let-handleClick="handleClickFn">
					<!-- <ng-container *ngIf="esidDisambiguationItem.originalModel?.isCreateCheckBox; else updateTemplate">
						<span class="create-ticket-label">{{
							appStrings.IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_CREATE_NEW_TICKET
						}}</span>
					</ng-container> -->
					<!-- <ng-template #updateTemplate> -->
					<div class="custom-content-wrapper">
						<ticket-thumbnail
							(click)="handleClick()"
							[ticketType]="esidDisambiguationItem.originalModel?.ticket?.view?.type"
							[ticketRole]="esidDisambiguationItem.originalModel?.ticket?.view?.liveRole"
						>
						</ticket-thumbnail>
						<div
							class="custom-content-data"
							(click)="focusTicket(esidDisambiguationItem.originalModel?.ticket)"
						>
							<h4 class="ticket-activity-name">
								{{ esidDisambiguationItem.originalModel?.ticket?.view?.activityName }}
							</h4>
							<div class="ticket-details">
								<span
									>{{ esidDisambiguationItem.originalModel?.ticket?.view?.liveStart }} -
									{{ esidDisambiguationItem.originalModel?.ticket?.view?.liveFinish }}</span
								>
								<span *ngIf="esidDisambiguationItem.originalModel?.swimlaneBelonging?.view?.label">
									{{ appStrings.IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_SWIMLANE_LABEL }}:
									{{ esidDisambiguationItem.originalModel.swimlaneBelonging?.view?.label }}</span
								>
							</div>
						</div>
					</div>
					<!-- </ng-template> -->
				</ng-template>
			</checkbox-list-item>
			<mat-divider></mat-divider>
		</ng-container>
	</checkbox-list>
</form>

<mat-divider class="padded-divider"></mat-divider>

<!-- Footer -->
<button-footer
	mat-dialog-actions
	(buttonSaveOrClose)="onNext()"
	[saveOrCloseButtonText]="saveOrCloseText$ | async | uppercase"
>
	<button leftButton type="button" mat-button mat-dialog-close color="primary" automationId="cancel">
		{{ appStrings.UICONTROL_TEXT_CANCEL.toUpperCase() }}
	</button>
</button-footer>
